import { Info } from 'lucide-react';
import type { EditorProps, WawiProductsConfig, WawiProductsLayout } from './types';

export function WawiProductsEditor({
  config,
  onChange,
}: EditorProps<WawiProductsConfig>) {
  const update = (patch: Partial<WawiProductsConfig>) => {
    onChange({ ...config, ...patch });
  };

  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <label className="text-xs font-medium text-neutral-300">Titel</label>
        <input
          type="text"
          value={config.title ?? ''}
          onChange={(e) => update({ title: e.target.value })}
          placeholder="z.B. Unsere Produkte"
          maxLength={200}
          className="w-full rounded-lg border border-surface-400 bg-surface-200 px-3 py-2 text-sm text-neutral-200 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
        />
      </div>

      <div className="space-y-1.5">
        <label className="text-xs font-medium text-neutral-300">Untertitel</label>
        <input
          type="text"
          value={config.subtitle ?? ''}
          onChange={(e) => update({ subtitle: e.target.value })}
          placeholder="optional"
          maxLength={200}
          className="w-full rounded-lg border border-surface-400 bg-surface-200 px-3 py-2 text-sm text-neutral-200 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
        />
      </div>

      <div className="space-y-1.5">
        <label className="text-xs font-medium text-neutral-300">Maximale Anzahl Produkte</label>
        <input
          type="number"
          min={1}
          max={50}
          value={config.maxProducts}
          onChange={(e) => {
            const n = Number(e.target.value);
            update({ maxProducts: Number.isFinite(n) ? Math.min(50, Math.max(1, Math.trunc(n))) : 12 });
          }}
          className="w-full rounded-lg border border-surface-400 bg-surface-200 px-3 py-2 text-sm text-neutral-200 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
        />
        <p className="text-[11px] text-neutral-500">Zwischen 1 und 50.</p>
      </div>

      <div className="space-y-1.5">
        <label className="text-xs font-medium text-neutral-300">Layout</label>
        <select
          value={config.layout}
          onChange={(e) => update({ layout: e.target.value as WawiProductsLayout })}
          className="w-full rounded-lg border border-surface-400 bg-surface-200 px-3 py-2 text-sm text-neutral-200 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
        >
          <option value="grid">Raster</option>
          <option value="list">Liste</option>
        </select>
      </div>

      <label className="flex items-center gap-3">
        <input
          type="checkbox"
          checked={config.showPrice}
          onChange={(e) => update({ showPrice: e.target.checked })}
          className="h-4 w-4 rounded border-surface-400 bg-surface-200 text-brand-500 focus:ring-1 focus:ring-brand-500"
        />
        <span className="text-sm text-neutral-200">Preise anzeigen</span>
      </label>

      <div className="space-y-1.5">
        <label className="text-xs font-medium text-neutral-300">Suche</label>
        <input
          type="text"
          value={config.search ?? ''}
          onChange={(e) => update({ search: e.target.value })}
          placeholder="Produktname / SKU"
          maxLength={200}
          className="w-full rounded-lg border border-surface-400 bg-surface-200 px-3 py-2 text-sm text-neutral-200 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
        />
        <p className="text-[11px] text-neutral-500">leer = alle Produkte</p>
      </div>

      <div className="flex items-start gap-2 rounded-lg border border-brand-900/50 bg-brand-900/10 p-3 text-xs text-brand-200">
        <Info className="mt-0.5 h-3.5 w-3.5 shrink-0" />
        <p>
          Produkte und Bilder werden serverseitig aus der WaWi geladen. Der Widget-Token bleibt
          im Backend und wird nie an Besucher ausgeliefert.
        </p>
      </div>
    </div>
  );
}
